<template>
  <div class="about" style="padding:15px">
    <q-card bordered class="my-card">
      <q-card-section class="bg-purple-6 text-white">
        <div class="row">
          <div class="col-12 col-md-9">
            <div class="row" style="margin: 0 5px 2px">
            <div class="text-h6">Data Master Level Pengguna</div>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="row" style="margin: 0 5px 2px">
              <q-input color="light-blue-7" v-model="cari_value" @keyup="cari_data()" outlined square :dense="true" class="bg-white" style="width:85%"/>
              <q-btn glossy class="bg-light-blue-7" @click="mdl_add = true" dense flat icon="add" style="width:15%">
                <q-tooltip class="bg-light-blue-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">
                  Tambah Data
                </q-tooltip>
              </q-btn>
            </div>
          </div>
        </div>
      </q-card-section>

      <q-separator dark inset />

      <q-card-section>
        <div class="tbl_responsive">
          <!-- =================================================== KONTENT =========================================================== -->
            <table width="100%">
              <tr class="h_table_head bg-purple-2">
                <th width="2.5%" class="text-center">No</th>
                <th width="20%">Uraian</th>
                <th width="10%">Keterangan</th>
                <th width="7.5%" class="text-center">#</th>
              </tr>
              <tr class="h_table_body" v-for="(data, index ) in list_data" :key="data.id">
                <td class="text-center">{{index+1}}</td>
                <td>{{data.uraian}}</td>
                <td>{{data.keterangan}}</td>
                <td class="text-center">
                  <q-btn-group>
                    <q-btn @click="mdl_edit = true, selectData(data)" glossy color="amber-7" icon="create" class="tbl_btn">
                      <q-tooltip class="bg-amber-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">
                        Edit Data
                      </q-tooltip>
                    </q-btn>
                    <q-btn @click="mdl_hapus = true, selectData(data)" glossy color="deep-orange-7" icon="delete_forever" class="tbl_btn">
                      <q-tooltip class="bg-deep-orange-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">
                        Hapus Data
                      </q-tooltip>
                    </q-btn>
                  </q-btn-group>
                </td>
              </tr>
            </table>

          <!-- =================================================== KONTENT =========================================================== -->
        </div>
        <hr class="hrpagin">
        <br>
        <div class="text-center">
          <q-btn @click="btn_prev" glossy color="purple-6" icon="skip_previous" class="paginate_btn" />
            <span class="h_pagination">&nbsp; {{page_first}} - {{page_last}} &nbsp;</span>
          <q-btn @click="btn_next" glossy color="purple-6" icon="skip_next" class="paginate_btn" />
        </div>
        <br>
      </q-card-section>
    </q-card>

          <!-- =================================================== MODAL =========================================================== -->

            <!-- ================================================= MODAL TAMBAH ================================================ -->
              <q-dialog v-model="mdl_add" persistent>
                <q-card class="mdl-md">
                  <q-card-section class="bg-light-blue-7">
                    <div class="text-h6 h_modalhead">Tambah Data</div>
                  </q-card-section>

                  <form @submit.prevent="addData()">
                    <q-card-section class="q-pt-none">
                        <br>
                        <span class="h_lable">Uraian</span>
                        <q-input v-model="form.uraian" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" /> 

                        <span class="h_lable">Keterangan</span>
                        <q-input v-model="form.keterangan" color="light-blue-7" outlined :dense="true" type="textarea" class="bg-white margin_input" />

                    </q-card-section>

                    <q-card-actions class="bg-grey-3 mdl-footer" align="right">
                        <q-btn :loading="btn_add" color="light-blue-7" type="submit" label="Simpan" />
                        <q-btn label="Kembali" color="grey-7" v-close-popup />
                    </q-card-actions>
                  </form>

                </q-card>
              </q-dialog>
            <!-- ================================================= MODAL TAMBAH ================================================ -->

            <!-- ================================================= MODAL EDIT ================================================ -->
            <q-dialog v-model="mdl_edit" persistent>
                <q-card class="mdl-md">
                  <q-card-section class="bg-amber-7">
                    <div class="text-h6 h_modalhead">Edit Data</div>
                  </q-card-section>

                  <form @submit.prevent="editData()">

                  <q-card-section class="q-pt-none">
                    <br>

                    <span class="h_lable">Uraian</span>
                    <q-input v-model="form.uraian" color="amber-7" outlined :dense="true" class="bg-white margin_input" /> 

                    <span class="h_lable">Keterangan</span>
                    <q-input v-model="form.keterangan" color="amber-7" outlined :dense="true" type="textarea" class="bg-white margin_input" />          

                  </q-card-section>

                  <q-card-actions class="bg-grey-2 mdl-footer" align="right">
                    
                      <q-btn :loading="btn_add" color="amber-7" type="submit" label="Simpan"  />
                      <q-btn label="Kembali" color="grey-7" v-close-popup />
             
                  </q-card-actions>
                  </form>
                </q-card>
              </q-dialog>
            <!-- ================================================= MODAL EDIT ================================================ -->

            <!-- ================================================ MODAL HAPUS ================================================ -->
            <q-dialog v-model="mdl_hapus" persistent>
                    <q-card class="mdl-sm ">
                      <q-card-section class="q-pt-none text-center bg-deep-orange-3">
                          <form @submit.prevent="removeData(form.id)">
                              <br>
                              <img src="img/alert.png" alt="" width="75"> <br>
                              <span class="h_notifikasi">APAKAH ANDA YAKIN INGIN MENGHAPUS DATA INI??</span>
                              <input type="submit" style="position: absolute; left: -9999px"/>
                              <br>
                              <br>
                            <q-btn label="Kembali" size="sm" color="grey-7"  v-close-popup/>
                            &nbsp;
                            <q-btn type="submit" label="Hapus" size="sm" color="deep-orange-7" v-close-popup/>

                          </form>
                      </q-card-section>
                    </q-card>
                  </q-dialog>

            <!-- ================================================ MODAL HAPUS ================================================ -->

          <!-- =================================================== MODAL =========================================================== -->

  </div>
</template>

<style>
</style>

<script>
export default {
  name: 'UmumPage',
  data() {
    return {
      form : {
        id : '',
        uraian : '',
        keterangan : '',
        createdAt : '',
        editedAt : '',
        userId : '',
      },

      list_data : [],

      page_first: 1,
      page_last: 0,
      page_limit: 10,
      cari_value: "",

      mdl_add: false,
      mdl_edit: false,
      mdl_hapus: false,
    }
  },
  methods: {
    getView : function(){
      this.$store.commit('showLoading');
      fetch(this.$store.state.url.URL_LEVEL + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },

    addData : function() {
      fetch(this.$store.state.url.URL_LEVEL + "addData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
                uraian : this.form.uraian,
                keterangan : this.form.keterangan
            })
      }).then(res_data => {
          this.Notify('Sukses Menambah Data', 'light-blue-7', 'check_circle_outline');
          console.log(res_data);
          this.getView();
      });
    },

    editData : function(){
      fetch(this.$store.state.url.URL_LEVEL + "editData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
                id : this.form.id,
                uraian : this.form.uraian,
                keterangan : this.form.keterangan
            })
      }).then(res_data => {
          this.Notify('Sukses Mengedit Data', 'amber-7', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(){
      fetch(this.$store.state.url.URL_LEVEL + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : this.form.id})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'deep-orange-7', 'check_circle_outline');
          this.getView();
      });

    },

    selectData: function(data) {
        this.form.id = data.id
        this.form.uraian = data.uraian
        this.form.keterangan = data.keterangan
        this.form.createdAt = data.createdAt
        this.form.editedAt = data.editedAt
        this.form.userId = data.userId
    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, color, icon){
          this.$q.notify({
            message: message,
            color: color,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },


    // ====================================== PAGINATE ====================================

  },
  mounted() {
    this.getView();
  }
}
</script>
